import { Pill, PillProps } from '@mantine/core';

import classNames from './Pill.module.scss';

/** @deprecated Use `Badge` from `@zorro/design-system/v2/Badge` instead */
export const ZorroPill = (props: PillProps) => {
  return <Pill classNames={classNames} {...props} />;
};
